import styled from '@emotion/styled';
import { Col, Input } from 'antd';
import React from 'react';
import { connect } from 'react-redux';

import { AppState } from 'src/config/appState';
import { Topics } from 'src/modules/programs/components/Topics';
import { color, font, mediaQueries } from 'src/shared/styles/variables';

import { PlannedActivity } from '../../weekThree/models/weekThree';
import { getPlannedActivities } from '../../weekThree/selectors/weekThreeSelectors';
import { changeAccomplishedActivityStatus } from '../actions/weekFourActions';
import { checkInActionsAnswer } from '../models/weekFourData';

const DescribeFeelingWrapper = styled(Col)({
    backgroundColor: color.aquaSpring,
    borderRadius: 5,
    padding: '1.75rem',
    marginTop: '0.66rem',
    [mediaQueries.sm]: {
        padding: '0.88rem',
    },
});

const Header = styled('h4')(
    {
        color: color.chathamsBlue,
        width: '100%',
        marginBottom: '0.44rem',
    },

    font.heavy(font.size.mediumExtended),
);

const StyledInput = styled<any>(Input)({
    marginTop: '1.31rem',
    maxWidth: '26.25rem',
});

interface StateProps {
    plannedActivities: PlannedActivity[];
}

interface ActionProps {
    changeAccomplishedActivityStatus: typeof changeAccomplishedActivityStatus;
}

interface Props extends ActionProps, StateProps {
    activity: PlannedActivity;
}

class DescribeFeelingContainer extends React.Component<Props> {
    private changeAccomplishedActivityStatus = (value: string, field: string) => {
        const { activity } = this.props;

        this.props.changeAccomplishedActivityStatus({
            activityTitle: activity.title,
            areaTitle: activity.domainTitle,
            value,
            field,
        });
    };

    private handleAnswerAdditionalInfoChange = (field: string) => (
        e: React.ChangeEvent<HTMLTextAreaElement>,
    ) => this.changeAccomplishedActivityStatus(e.target.value, field);

    private handleAnswerChange = (value: string) =>
        this.changeAccomplishedActivityStatus(value, 'checkInActionsAnswer');

    public render(): JSX.Element {
        const { activity } = this.props;

        return (
            <DescribeFeelingWrapper span={24}>
                <Header>How did you feel when you took this action?</Header>
                <Topics
                    topics={checkInActionsAnswer}
                    onTopicChange={this.handleAnswerChange}
                    selectedTopics={[activity.checkInActionsAnswer]}
                />
                <StyledInput
                    value={activity.additionalTitle && activity.additionalTitle}
                    size="large"
                    placeholder="E.g. I was proud of myself for making time for this."
                    onChange={this.handleAnswerAdditionalInfoChange('additionalTitle')}
                />
            </DescribeFeelingWrapper>
        );
    }
}

const mapStateToProps = (state: AppState) => ({
    plannedActivities: getPlannedActivities(state),
});

export const DescribeFeeling = connect(mapStateToProps, { changeAccomplishedActivityStatus })(
    DescribeFeelingContainer,
);
